module.exports = __webpack_public_path__ + "img/editIcon.dfdefae5.svg";